.wrapper-trial {
  flex-direction: column;

  .form-wrapper {
    height: 70px;

    .form-section {
      display: flex;
      gap: calc(var(--spacer) * 4);
      position: fixed;
      z-index: 1;
      margin-top: 5px;

      .msp-country-form-section {
        display: flex;
        flex-direction: column;
      }

      .msp-industry-form-section {
        display: flex;
        flex-direction: column;
      }
    }
  }
}
